import { createStyles, Container, Title, Button, Group, Text, rem, Flex } from "@mantine/core"
import { useMediaQuery } from "@mantine/hooks"
import heroImage from "shared/assets/home-hero.svg"
import { directionRoutes } from "shared/lib/constants"
import React from "react"

const useStyles = createStyles((theme) => ({
  inner: {
    paddingBottom: "4rem",

    [theme.fn.smallerThan("md")]: {
      paddingBottom: "3rem",
    },

    [theme.fn.smallerThan("xs")]: {
      paddingBottom: "1.5rem",
    },
  },

  content: {
    borderRadius: `${theme.radius.xl} 0 0 ${theme.radius.xl}`,
    background:
      theme.colorScheme === "dark"
        ? `linear-gradient(to right, ${theme.colors.indigo[9]}, transparent)`
        : `linear-gradient(to right, ${theme.colors.indigo[2]}, transparent)`,
    padding: rem(56),
    flex: 3,

    [theme.fn.smallerThan("md")]: {
      borderRadius: theme.radius.xl,
      background: theme.fn.linearGradient(45, "#1d46de", theme.colors.blue[3]),
    },

    [theme.fn.smallerThan("xs")]: {
      padding: theme.spacing.xl,
    },
  },

  title: {
    fontSize: rem(32),
    fontWeight: 700,

    [theme.fn.smallerThan("md")]: {
      fontSize: rem(26),
      color: theme.white,
    },
  },

  text: {
    paddingTopTop: theme.spacing.lg,
    fontSize: rem(18),

    [theme.fn.smallerThan("md")]: {
      color: theme.white,
      fontSize: rem(16),
    },
  },

  imageContainer: {
    flex: 2,
    display: "flex",
    alignItems: "stretch",
    borderRadius: theme.radius.xl,
    overflow: "hidden",

    [theme.fn.smallerThan("md")]: {
      display: "none",
    },
  },

  image: {
    width: "100%",
    height: "auto",
    objectFit: "cover",
  },
}))

const Category = () => {
  const { theme } = useStyles()
  const matches = useMediaQuery(`(max-width: ${theme.breakpoints.md})`)

  return (
    <Group maw={768} spacing="xs">
      {directionRoutes.map(({ label, linkTo }) => (
        <Button
          rel="noopener noreferrer"
          href={linkTo}
          component="a"
          target="_blank"
          key={linkTo}
          variant={matches ? "white" : "filled"}
          color="dark"
          radius="xl"
        >
          {label}
        </Button>
      ))}
    </Group>
  )
}

export function HomeHero(): React.JSX.Element {
  const { classes } = useStyles()

  return (
    <Container size={1440} className={classes.inner}>
      <Flex>
        <Flex direction="column" justify="space-between" className={classes.content}>
          <span/>
          <Title className={classes.title}>
            Body Coach - образовательная платформа №1
            <br/>в сфере фитнеса и нутрициологии
          </Title>
          <Flex direction="column" gap="xl" mt="xl">
            <Text className={classes.text}>Станьте сертифицированным специалистом и повысьте свою квалификацию</Text>
            <Category/>
          </Flex>
        </Flex>
        <div className={classes.imageContainer}>
          <img src={heroImage} alt="Главное изображение" className={classes.image}/>
        </div>
      </Flex>
    </Container>
  )
}
